import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Buefy from 'buefy';
import VueMoment from 'vue-moment';
import moment from 'moment';
import VSwatches from 'vue-swatches';
import 'moment/locale/da';
import './filters/numbers';
import './filters/dates'; 
import '@fontsource/lato';
import Icon from "./components/common/Icon.vue";

import { library } from '@fortawesome/fontawesome-svg-core';
import { faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle, faExclamationCircle,
         faArrowUp, faAngleRight, faAngleLeft, faAngleDown, faPlus, faBars, faComment, faTimes,
         faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload, faEnvelope, faLock, faChevronLeft,faStickyNote,
         faChevronRight, faBell } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
library.add(faCheck, faCheckCircle, faInfoCircle, faExclamationTriangle, faExclamationCircle, 
            faArrowUp, faAngleRight, faAngleLeft, faAngleDown, faPlus, faBars, faComment, faTimes, faStickyNote,
            faEye, faEyeSlash, faCaretDown, faCaretUp, faUpload, faEnvelope, faLock, faChevronLeft,
            faChevronRight, faBell);

require('./styles/app.scss');

moment.locale('da');
Vue.use(VueMoment, { moment });
Vue.config.productionTip = false

Vue.component("v-swatches", VSwatches);
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component("icon", Icon);

Vue.use(Buefy, {
  defaultIconComponent: 'font-awesome-icon',
  defaultIconPack: 'fas',
  defaultContainerElement: '#content',
  defaultModalScroll: 'keep'
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
